import { render } from "./MoviesBanner.vue?vue&type=template&id=df104820&ts=true"
import script from "./MoviesBanner.vue?vue&type=script&lang=ts"
export * from "./MoviesBanner.vue?vue&type=script&lang=ts"

import "./MoviesBanner.vue?vue&type=style&index=0&id=df104820&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__